export class ContentFileUpload {
    name: string;
    url: string;
    file: File;
    progress: number;
    constructor(file: File) {
      this.file = file;
    }
}


// WEBPACK FOOTER //
// /app/src/app/core/models/content-files-upload.ts